export const STEP = {
  COMPOSE: 'compose',
  PREVIEW: 'preview',
  SUCCESS: 'success',
} as const;

export type Step = (typeof STEP)[keyof typeof STEP];

export interface MessageCreator {
  id: string;
  displayName: string;
  imageUrl: string;
}
